webpackJsonp([17],{

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(239),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9IiM1NTU1RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS40MjM4IDE3LjU2ODFDMzEuNzc1MiAxNy43MzI2IDMxLjk5OTcgMTguMDg1NiAzMS45OTk3IDE4LjQ3MzZWNDIuMTU3OUMzMS45OTk3IDQyLjU0NTkgMzEuNzc1MiA0Mi44OTg5IDMxLjQyMzggNDMuMDYzNEMzMS4wNzI1IDQzLjIyOCAzMC42NTc2IDQzLjE3NDUgMzAuMzU5NSA0Mi45MjYxTDIyLjc0MjkgMzYuNTc4OUgyMC40NzM0QzE4LjQ2NzcgMzYuNTc4OSAxNi44NDE4IDM0Ljk1MyAxNi44NDE4IDMyLjk0NzNWMjcuNjg0MkMxNi44NDE4IDI1LjY3ODUgMTguNDY3NyAyNC4wNTI2IDIwLjQ3MzQgMjQuMDUyNkgyMi43NDI5TDMwLjM1OTUgMTcuNzA1NEMzMC42NTc2IDE3LjQ1NyAzMS4wNzI1IDE3LjQwMzUgMzEuNDIzOCAxNy41NjgxWk0zOC4xODczIDIxLjcxMzlDMzguNTc3OCAyMS4zMjM0IDM5LjIxMSAyMS4zMjM0IDM5LjYwMTUgMjEuNzEzOUM0MS44NTc0IDIzLjk2OTggNDIuNTI2IDI3LjU5MjQgNDIuNTI2IDMwLjMxNThDNDIuNTI2IDMzLjAzOTEgNDEuODU3NCAzNi42NjE3IDM5LjYwMTUgMzguOTE3NkMzOS4yMTEgMzkuMzA4MSAzOC41Nzc4IDM5LjMwODEgMzguMTg3MyAzOC45MTc2QzM3Ljc5NjggMzguNTI3MSAzNy43OTY4IDM3Ljg5MzkgMzguMTg3MyAzNy41MDM0QzM5Ljg3ODggMzUuODExOSA0MC41MjYgMzIuODU1NSA0MC41MjYgMzAuMzE1OEM0MC41MjYgMjcuNzc2IDM5Ljg3ODggMjQuODE5NiAzOC4xODczIDIzLjEyODFDMzcuNzk2OCAyMi43Mzc2IDM3Ljc5NjggMjIuMTA0NCAzOC4xODczIDIxLjcxMzlaTTM0LjI0IDI1LjY2MTJDMzQuNjMwNSAyNS4yNzA3IDM1LjI2MzcgMjUuMjcwNyAzNS42NTQyIDI1LjY2MTNDMzYuNTMyOCAyNi41Mzk5IDM3LjI2MjggMjguMTI3OCAzNy4yNjI4IDMwLjMxNThDMzcuMjYyOCAzMi41MDM3IDM2LjUzMjggMzQuMDkxNiAzNS42NTQyIDM0Ljk3MDJDMzUuMjYzNiAzNS4zNjA3IDM0LjYzMDUgMzUuMzYwNyAzNC4yNCAzNC45NzAyQzMzLjg0OTQgMzQuNTc5NyAzMy44NDk0IDMzLjk0NjUgMzQuMjQgMzMuNTU2QzM0LjY3NzEgMzMuMTE4OSAzNS4yNjI4IDMyLjA3NTIgMzUuMjYyOCAzMC4zMTU4QzM1LjI2MjggMjguNTU2MyAzNC42NzcxIDI3LjUxMjYgMzQuMjM5OSAyNy4wNzU1QzMzLjg0OTQgMjYuNjg0OSAzMy44NDk0IDI2LjA1MTggMzQuMjQgMjUuNjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var getSettings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var settings;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.localStorage.engsettings) {
              _context.next = 6;
              break;
            }

            settings = JSON.parse(window.localStorage.engsettings);

            console.log("GOT SETTINGS FROM LOCALSTORAGE");

            return _context.abrupt("return", settings);

          case 6:
            console.log("WAS MADE");
            window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));

          case 8:
            return _context.abrupt("return", [true, true]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSettings() {
    return _ref.apply(this, arguments);
  };
}();

var setSettings = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(newsetting) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.localStorage.engsettings) {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newsetting));
            } else {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var settingsService = {
  getSettings: getSettings,
  setSettings: setSettings
};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("341b2bf2", content, true, {});

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "#progressBar{position:relative;top:-7px}.slider::-moz-range-thumb{width:20px;height:20px;border-radius:50%;background:#555fff;cursor:pointer}.slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:20px;height:20px;background:#555fff;border-radius:50%;cursor:pointer}.disabledBtn{display:none}.audio-player-container{display:flex;align-items:center;justify-content:center;gap:8px}.speed-btn{background:var(--bg-primary, #555fff);color:#fff;border:none;border-radius:16px;padding:4px 8px;font-size:12px;font-weight:500;min-width:36px;height:24px;cursor:pointer;transition:all .2s ease;user-select:none}.speed-btn:hover{background:var(--bg-primary-hover, #4444ee);transform:scale(1.05)}.speed-btn:active{transform:scale(0.95)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/AudioPlayer.scss"],"names":[],"mappings":"AAAA,aACE,kBAEA,QAAA,CAGF,0BACE,WACA,YACA,kBAEA,mBACA,cAAA,CAGF,8BACE,wBACA,gBACA,WACA,YACA,mBACA,kBACA,cAAA,CA4DF,aACE,YAAA,CAGF,wBACE,aACA,mBACA,uBACA,OAAA,CAGF,WACE,sCACA,WACA,YACA,mBACA,gBACA,eACA,gBACA,eACA,YACA,eACA,wBACA,gBAAA,CAEA,iBACE,4CACA,qBAAA,CAGF,kBACE,qBAAA,CAAA","file":"AudioPlayer.scss","sourcesContent":["#progressBar {\n  position: relative;\n  // top: -9px;\n  top: -7px;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n\n  background: #555fff;\n  cursor: pointer;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #555fff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n// input[type=\"range\"] {\n//   -webkit-appearance: none;\n//   // margin-right: 15px;\n//   width: 120px;\n//   height: 7px;\n//   background: #aaabbb;\n//   border-radius: 5px;\n//   background-position: right center;\n//   background-image: linear-gradient(#7070af, #111199);\n//   background-size: 0% 100%;\n//   background-repeat: no-repeat;\n// }\n\n// input[type=\"range\"]::-webkit-slider-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #555;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-moz-range-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #390b8d;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// input[type=\"range\"]::-moz-range-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE\n// .slider::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: blue;\n// }\n\n.disabledBtn {\n  display: none;\n}\n\n.audio-player-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.speed-btn {\n  background: var(--bg-primary, #555fff);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  \n  &:hover {\n    background: var(--bg-primary-hover, #4444ee);\n    transform: scale(1.05);\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_settingsService__ = __webpack_require__(209);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AudioPlayer",
  data: function data() {
    return {
      audioFile: null,
      audio: null,
      progressBar: 0,
      isPlaying: null,
      soundSetting: null,
      speakSetting: null,
      playbackRate: 1,
      availableSpeeds: [1, 1.25, 1.5, 2]
    };
  },

  props: {
    urlId: {
      type: String | Number,
      require: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    audioSrc: { type: String, required: true }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_settingsService__["a" /* settingsService */].getSettings();

            case 2:
              _this.soundSetting = _context.sent;

              _this.loadSavedSpeed();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    console.log(this.hideProgressBar);
    if (this.urlId) {
      this.getAudio();
    } else {
      this.audioFile = this.audioSrc;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.audio.pause();
  },

  watch: {
    urlId: function urlId() {
      // this.isStop = true;
      this.getAudio();
    },
    audioFile: function audioFile() {
      this.makeAudio(this.audioFile);
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.speakSetting = this.soundSetting[1];
      }
      if (this.audio && this.autoPlay && this.speakSetting) this.play();
    },
    audio: function audio() {
      console.log(this.speakSetting);
      if (this.autoPlay && this.speakSetting) this.play();
    },
    progressBar: function progressBar() {
      this.$refs.progressBar.style.backgroundSize = (this.progressBar - 0) * 100 / (100 - 0) + "% 100%";
    },
    $route: function $route(to, from) {
      this.audio.pause();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this2 = this;

      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
            var _ref2, mediaUrl;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context2.sent;
                    mediaUrl = _ref2.mediaUrl;

                    _this2.audioFile = mediaUrl;

                    //this.makeAudio(this.audioFile);
                    // if (this.autoplay) {
                    //   this.isStop = false;
                    //   this.playAudio();
                    // }

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioFile = null;
      }
    },
    changeProgress: function changeProgress(e) {
      if (this.audio) this.audio.currentTime = this.audio.duration / 100 * e.target.value;
      var el = e.target;
      console.log((el.value - 0) * 100 / (100 - 0) + "% 100%");
      el.style.backgroundSize = (el.value - 0) * 100 / (100 - 0) + "% 100%";
    },
    play: function play(e) {
      console.log(this.audio.paused);
      if (e) e.stopPropagation();
      if (!this.audio.paused) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    },
    pause: function pause() {
      this.audio.pause();
    },
    makeAudio: function makeAudio(audioFile) {
      var _this3 = this;

      this.audio = new Audio(audioFile);

      this.audio.volume = 0.5;
      this.audio.playbackRate = this.playbackRate;
      this.audio.addEventListener("timeupdate", function (e) {
        _this3.progressBar = _this3.audio.currentTime / _this3.audio.duration * 100;
      });

      this.audio.addEventListener("ended", function () {
        _this3.audio.currentTime = 0;
        _this3.audio.pause();
      });
    },
    cycleSpeed: function cycleSpeed() {
      var currentIndex = this.availableSpeeds.indexOf(this.playbackRate);
      var nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackRate = this.availableSpeeds[nextIndex];

      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }

      // שמירת המהירות ב-localStorage
      localStorage.setItem('audioPlaybackRate', this.playbackRate);
    },
    loadSavedSpeed: function loadSavedSpeed() {
      var savedRate = localStorage.getItem('audioPlaybackRate');
      if (savedRate && this.availableSpeeds.includes(parseFloat(savedRate))) {
        this.playbackRate = parseFloat(savedRate);
      }
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "audio-player-container"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        __webpack_require__(208).default :
        __webpack_require__(240).default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.playbackRate) + "x\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDg5ODQiIHdpZHRoPSI1Ljc3MTgxIiBoZWlnaHQ9IjI1IiByeD0iMi44ODU5MSIgZmlsbD0iIzU1NTVGRiIvPgo8cmVjdCB4PSIxMC4zMjkxIiB3aWR0aD0iNS43NzE4MSIgaGVpZ2h0PSIyNSIgcng9IjIuODg1OTEiIGZpbGw9IiM1NTU1RkYiLz4KPC9zdmc+Cg==");

/***/ })

});


// WEBPACK FOOTER //
// 17.ce03fd3d81a126f24b18.bundle.js